// extracted by mini-css-extract-plugin
export default {"component":"BattleRight_component__tZ7ur"};